import { useContext } from 'react'
import { AppUpdateContext, type AppUpdateContextValue } from './update-context'

export function useAppUpdate(): AppUpdateContextValue {
  const value = useContext(AppUpdateContext)
  if (!value) throw new Error('useAppUpdate는 AppUpdateProvider 안에서만 쓴다')
  return value
}
